// Define base URLs
const BASE_URL_USER = 'https://smartrainmakers.com/api';
// const BASE_URL_USER = 'http://127.0.0.1:4000/api';

export const RPC_BASE_URL = "https://bsc-dataseed.bnbchain.org"
export const USDT_CONTRACT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955"

// Define endpoints
const ENDPOINTS = {
  last24hours: `${BASE_URL_USER}/last24hours`,
  login: `${BASE_URL_USER}/login`,
  register: `${BASE_URL_USER}/register`,
  generateOTP: `${BASE_URL_USER}/generate-otp`,
  verifyOTP: `${BASE_URL_USER}/verify-otp`,
  forgotPassword: `${BASE_URL_USER}/forgot-password`,

  getUserDetails: `${BASE_URL_USER}/user-details`,
  changePassword: `${BASE_URL_USER}/change-password`,
  fetchNotifications: `${BASE_URL_USER}/notifications`,
  updateProfile: `${BASE_URL_USER}/update-profile`,
  operation: `${BASE_URL_USER}/operation`,
  searchUser: `${BASE_URL_USER}/search-user`,
  transferAmount: `${BASE_URL_USER}/transfer-amount`,
  withdraw: `${BASE_URL_USER}/withdraw`,
  transactions: `${BASE_URL_USER}/transactions`,
  raiseTicket: `${BASE_URL_USER}/support/raise-ticket`,
  fetchTickets: `${BASE_URL_USER}/support/fetch-tickets`,
  checkUplineStatus: `${BASE_URL_USER}/check-upline-activation`,
  enable2FA: `${BASE_URL_USER}/enable-2fa`,
  disable2FA: `${BASE_URL_USER}/disable-2fa`,
  verify2FA: `${BASE_URL_USER}/verify-2fa`,
};

export default ENDPOINTS;